const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export async function uploadToCloudinary(file, folder = 'sapan') {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', folder);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) throw new Error('Upload gagal');
  const data = await res.json();

  // Tambahkan transformasi otomatis:
  // q_auto = kualitas otomatis (kompresi pintar)
  // f_auto = format otomatis (WebP di browser yang support, JPEG di yang tidak)
  // w_1200 = max width 1200px (cukup untuk banner, tidak perlu lebih besar)
  const optimizedUrl = data.secure_url.replace(
    '/upload/',
    '/upload/q_auto,f_auto,w_1200/'
  );

  return optimizedUrl;
}

// Untuk thumbnail (foto produk di card) — lebih kecil
export function toThumbnail(url) {
  if (!url || !url.includes('/upload/')) return url;
  return url.replace('/upload/', '/upload/q_auto,f_auto,w_400,h_300,c_fill/');
}
